import React from 'react';
import {ReactComponent as ReactLogo} from '../style/images/whatsapp.svg';

export default function Whatsapp() {
    return (
        <a href="https://api.whatsapp.com/send?phone=5511982724237" target="_blank" rel="noopener noreferrer" className="btn botaoWhatsApp animated wow slideInLeft animation-delay-1">
            <ReactLogo />
        </a>
    );
}